// A product can be capped per store and overall; whichever limit is tighter is the one that takes it
// off the menu. Absent limits mean unlimited, which is the common case.
export function isProductSoldOut(product) {
  const remaining = [product?.product_inventory_remaining, product?.store_inventory_remaining].filter(
    (value) => value != null
  )
  if (!remaining.length) return false
  return Math.min(...remaining) <= 0
}

// V1 serves an upsell list the backend has already filtered - Cart#upsell_category_product_store_pairs
// drops products in the cart and anything with no stock left. V2 gets the raw category on the store
// payload, so it has to apply the same two rules to reach parity.
export function availableUpsellCategory(category, { cartProductIds = [] } = {}) {
  if (!category) return null

  const inCart = new Set(cartProductIds)
  const products = (category.products || []).filter((p) => !inCart.has(p.id) && !isProductSoldOut(p))

  return products.length > 0 ? { ...category, products } : null
}
